export default __webpack_public_path__ + "static/media/nft9.59f62e1a.png";